import VueClipboard from 'vue-clipboard2';
import Vue from 'vue';

export default function vueClipboard2() {
  VueClipboard.config.autoSetContainer = true;
  Vue.use(VueClipboard);
}
